import { Chip, Typography } from "@mui/material";
import { useAppSelector } from "../../../../app/hooks";
import { ChipListProps } from "./types";
import { useTranslation } from "react-i18next";

const ChipList = <T extends Record<string, any>>({
  list,
  idKey,
  labelKey,
  translationKey = "",
  onDelete,
  onClick,
  getChipStyles,
  sx = {},
  emptyState,
  size = "medium",
}: ChipListProps<T>) => {
  const { t } = useTranslation();
  const translations = useAppSelector((state) => state.localized);

  if (!list)
    return <Typography>{emptyState || t("common.noItems")}</Typography>;

  const selectedTranslations = translationKey
    ? translations[translationKey]
    : null;

  const getLabel = (item: T): string => {
    if (labelKey) return item[labelKey];
    if (selectedTranslations)
      return selectedTranslations[item[idKey]] || item[idKey];
    // fallback to id
    return item[idKey];
  };

  return (
    <>
      {list.map((item) => {
        const chipStyles = getChipStyles ? getChipStyles(item[idKey]) : {};

        return (
          <Chip
            size={size}
            key={item[idKey] as string | number}
            sx={{
              ...sx,
              ...chipStyles,
            }}
            label={getLabel(item)}
            onDelete={onDelete ? () => onDelete(item[idKey]) : undefined}
            onClick={onClick ? () => onClick(item[idKey]) : undefined}
          />
        );
      })}
    </>
  );
};

export default ChipList;
